import { emailApiService } from './emailApiService';

class EmailPollingService {
    private static instance: EmailPollingService;
    private pollingInterval: NodeJS.Timeout | null = null;
    private isPolling: boolean = false;
    private listeners: (() => void)[] = [];

    private constructor() { }

    public static getInstance(): EmailPollingService {
        if (!EmailPollingService.instance) {
            EmailPollingService.instance = new EmailPollingService();
        }
        return EmailPollingService.instance;
    }

    public startPolling(intervalMs: number = 60000) {
        if (this.pollingInterval) return;

        console.log('📧 Starting email polling...');
        this.poll(); // Initial poll
        this.pollingInterval = setInterval(() => this.poll(), intervalMs);
    }

    public stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            console.log('📧 Stopped email polling');
        }
    }

    public async poll() {
        if (this.isPolling) return;
        this.isPolling = true;

        try {
            const result = await emailApiService.pollEmails();
            if (result.processed > 0) {
                console.log(`📧 Processed ${result.processed} new emails`);
                this.notifyListeners();
            }
        } catch (error) {
            console.error('Error polling emails:', error);
        } finally {
            this.isPolling = false;
        }
    }

    public subscribe(listener: () => void) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    private notifyListeners() {
        this.listeners.forEach(listener => listener());
    }
}

export const emailPollingService = EmailPollingService.getInstance();
